import { render, staticRenderFns } from "./addUser.vue?vue&type=template&id=073011b2&scoped=true&"
import script from "./addUser.vue?vue&type=script&lang=ts&"
export * from "./addUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073011b2",
  null
  
)

export default component.exports